export const supportedBrands = [
  "amex",
  "argencard",
  "bcmc",
  "bijcard",
  "cabal",
  "cartebancaire",
  "codensa",
  "cup",
  "dankort",
  "diners",
  "discover",
  "elo",
  "forbrugsforeningen",
  "hiper",
  "hipercard",
  "jcb",
  "karenmillen",
  "laser",
  "maestro",
  "maestrouk",
  "mc",
  "mcalphabankbonus",
  "mir",
  "naranja",
  "oasis",
  "shopping",
  "solo",
  "troy",
  "uatp",
  "visa",
  "visaalphabankbonus",
  "visadankort",
  "warehouse",
];
